import React, { useEffect } from 'react';
import './Animation.css';

const Animation = ({ numeroAciertos, cifraActual, closeAnimationHandler }) => {
    useEffect(() => {
        const bloqueAnimacion = document.getElementById('animation__container');
        bloqueAnimacion.style.animation = 'showAnimation 2s';
        setTimeout(() => {
            closeAnimationHandler();
        }, 2100);
    });

    let mensaje;
    let cifra;
    let classFallo;
    if (numeroAciertos === 'vocal') {
        mensaje = 'Está la vocal, ¡Muy bien!';
        cifra = '-50';
    } else if (numeroAciertos === 0) {
        classFallo = 'animation__container--fallo';
        mensaje = 'No hay ninguna';
        cifra = '+1 falta';
    } else {
        if (cifraActual === '1/2') {
            cifra = 'Divides 1/2';
        } else if (cifraActual === 'x2') {
            cifra = 'Multiplicas x2';
        } else {
            cifra = `+${cifraActual * numeroAciertos}`;
        }
        if (numeroAciertos === 1) {
            mensaje = `Hay ${numeroAciertos}, ¡Muy bien!`;
        } else if (numeroAciertos === 2) {
            mensaje = `Hay ${numeroAciertos}, ¡Perfecto!`;
        } else if (numeroAciertos >= 3) {
            mensaje = `Hay ${numeroAciertos}, ¡Excelente!`;
        }
    }

    return (
        <div id="animation__container" className={`animation__container ${classFallo}`}>
            <h2 className="animation__h2">{mensaje}</h2>
            <p className="animation__p">{cifra}</p>
        </div>
    );
};

export default Animation;
